import React, { Component } from 'react';
import nl2br from 'react-nl2br';
import { connect } from 'react-redux';
import './Assistant.scss';
import { detect } from 'detect-browser';


//icons
import {
    setTextToSpeak,
    loadContentForPage,
    alreadyPlayed,
    setData,
    loadText,
    isPlaying
} from '../../redux/actions/text.action';
import speak from '../../assets/speak.svg';
import Text2Voice from '../Text2Voice/Text2Voice';

const browser = detect();

/**
 * Component for the assistant, shown at the top of the screen.
 * Displayes two lines of text, passed in the props
 */
class Assistant extends Component<{ textLine1: string, textLine2: string, speak: any, readPage?: any, unBlockVoice: any, avatarname: string, avatarimg: any, text?: any, setData: any }, { message: any, play: boolean }> {
    private text2Voice: any;
    private concatedArray: any;

    constructor(props: any, context: any) {
        super(props, context);
        this.concatedArray = [];
        this.concatedArray.push(this.setAvatarName(this.props.textLine1) + this.setAvatarName(this.props.textLine2));
        this.concatedArray = this.concatedArray.concat(this.props.text);
        this.state = {
            message: this.concatedArray,
            play: false
        }
    }

    setAvatarName(text: string) {
        return text.replace('%avatarname', this.props.avatarname)
    }

    componentDidMount() {

    }

    /**
     * Main render method
     */
    render() {
        const isSafari = browser && (browser.name === 'safari' || browser.name === 'ios');
        return (
            <div className="assistant">
                {this.state.message.length > 0 &&
                    <Text2Voice textArray={this.state.message} playing={this.state.play} callback={() => {
                        this.setState({ message: [], play: false })
                    }} />}
                <img src={this.props.avatarimg} className="assistant-img" alt="avatar" onClick={() => {
                    //   this.text2Voice.replay();
                    setTimeout(() => {
                        this.setState({ message: this.concatedArray, play: true })
                    }, 1);
                    if (browser && (browser && browser.name !== 'safari' && browser.name !== 'ios')) {
                        this.setState({ message: [] })
                    }


                    this.forceUpdate()
                }} />
                <div className="assistant-textbox" onClick={() => {
                    // this.props.setData(textSpeech);
                    if (browser && (browser.os !== 'iOS' && browser.os !== 'Mac OS')) {
                        setTimeout(() => {
                            this.setState({ message: [this.setAvatarName(this.props.textLine1) + this.setAvatarName(this.props.textLine2)] })
                        }, 1);
                        this.setState({ message: [] })
                    }

                }}>
                    <div className="assistant-text1">{nl2br(this.setAvatarName(this.props.textLine1))}</div>
                    {this.props.textLine2 &&
                        <div>
                            <div className="assistant-text2">{nl2br(this.setAvatarName(this.props.textLine2))}</div>
                        </div>
                    }
                </div>
                {isSafari && <div className="speak" onClick={() => {
                    //   this.text2Voice.replay();
                    setTimeout(() => {
                        this.setState({ message: this.concatedArray, play: true })
                    }, 1);
                    if (browser && (browser && browser.name !== 'safari' && browser.name !== 'ios')) {
                        this.setState({ message: [] })
                    }


                    this.forceUpdate()
                }}>
                    <img src={speak} alt="speak" />
                    <span>Vorlesen</span>
                </div>}
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        avatarname: state.avatar.avatarName,
        avatarimg: state.avatar.avatarImg
    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {
        speak(text: string) {
            dispatch(setTextToSpeak(text))
        },
        setCurrentpage(page: string) {
            dispatch(loadContentForPage(page))
        },
        unBlockVoice() {
            dispatch(alreadyPlayed(false));
        },
        setData(data: any) {
            dispatch(loadText(data))
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Assistant);